//chapter1
export default {
    id : 11,//chapter number
    title : '11. 패키지 쏘잉 & 쏘팅 공정(Sawing & Sorting) (1)',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/11/videos/a11.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '쏘잉 공정의 의의',
            ],
            body2 : [
                '쏘잉 공정의 의의에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/11/videos/11.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '솔더 볼 불량현상은 원자재 불량에 의해 발생하지 않으므로 공정에서 발생원인을 찾아야 한다.',//html available
                    answer : "2",
                    explain : '솔더 볼 원자재 불량에 의해 불량이 발생할 수 있으므로 원자재 불량 여부도 체크하여야 한다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '솔더 볼 불량현상은 비전 검사를 통하면 모두 찾아낼 수 있으므로 육안검사는 필요하지 않다.',//html available
                    answer : "2",
                    explain : '육안검사를 진행하여 불량현상을 찾아낼 수 있도록 한다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>쏘잉 공정의 의의<br>
                        - PCB를 이용해 생산되는 패키지인 BOC(Board On Chip), BGA(Ball Grid Array), QFN(Quad Flat No-lead), LGA(Land Grid Array)를 포함하는 다양한 패키지는 리드프레임 대신 PCB를 사용하는데, 하나의 PCB위에 여러 개의 다이를 본딩하고 와이어 본딩을 한 후 PCB전체를 몰딩함<br>
                        - Strip으로부터 PKG를 개별화 시켜주는 쏘잉 공정<br>
                        - 개별화된 PKG를 Vision을 통해 양품/불량 검사 후 분류하는 쏘팅 공정<br>
                        - 몰딩이 끝난 상태의 기판에는 수십 개, 또는 수백 개의 반도체 소자가 형성되어 있으므로 여러 개의 소자가 한번에 몰딩이 되어 있는 유닛을 쏘잉 블레이드를 고속 회전시켜 개별화하는 쏘잉 공정을 진행하므로 제조 효율이 매우 높은 장점이 있음</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/11/videos/a11.mp4',
        },
    ]
}